import { render, staticRenderFns } from "./LayoutWechat.vue?vue&type=template&id=f7037e88"
import script from "./LayoutWechat.vue?vue&type=script&lang=js"
export * from "./LayoutWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports